import { useEffect, useState, useCallback } from 'react'
import { PULSING_VARIANTS } from 'domain/enums'
import { feedTitleKeys, feedDescriptionKeys } from 'shared/helpers'
import { navigateToUrl } from 'single-spa'
import { useParams } from 'react-router-dom'
import { DOCUMENT_PRODUCT_PATH } from 'domain/constants'

export const useFeed = lead => {
  const { id } = useParams()

  const [feedItems, setFeedItems] = useState([])
  const [showFade, setShowFade] = useState(true)

  const orderItemsByTimestamp = useCallback(feeds => {
    return feeds.sort((a, b) =>
      new Date(a.createdAt).getTime() > new Date(b.createdAt).getTime()
        ? -1
        : 1,
    )
  }, [])

  const handleDocumentRouterChange = () => {
    const documentProduct = DOCUMENT_PRODUCT_PATH[lead.productType] || ''
    navigateToUrl(`/documents/${documentProduct}/${id}`)
  }

  const resolveFeedColor = (name, done) => {
    if (name === feedTitleKeys.REJECTED) {
      return PULSING_VARIANTS.REJECTED
    }

    if (!done && name === feedTitleKeys.DOCUMENT_REQUIRED) {
      return PULSING_VARIANTS.PENDING
    }
    return PULSING_VARIANTS.INFO
  }

  const mountFeedTitle = (feedName, feedDescription) => {
    let title = feedName
    if (feedDescription === feedDescriptionKeys.CONTACT_WHATSAPP) {
      title = `${title} whatsapp.`
    }
    if (feedDescription === feedDescriptionKeys.CONTACT_EMAIL) {
      title = `${title} email.`
    }
    if (feedDescription === feedDescriptionKeys.CONTACT_CHAT) {
      title = `${title} chat.`
    }
    if (feedDescription === feedDescriptionKeys.CONTACT_PHONE) {
      title = `${title} telefone.`
    }
    return title
  }

  useEffect(() => {
    if (lead) {
      setFeedItems(orderItemsByTimestamp(lead.feeds))
    }
  }, [lead])

  return {
    feedItems,
    resolveFeedColor,
    handleDocumentRouterChange,
    showFade,
    setShowFade,
    mountFeedTitle,
  }
}
